<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Data Conversion
      <div slot="right">
        <b-button
          type="is-primary import-button"
          @click="routeToImportForm"
          v-if="isEditAllowed"
          >New Import</b-button
        >
      </div>
    </hero-bar>
    <section class="section is-main-section enable-select-text">
      <circul8-table
        :records="tableData"
        :fields="columns"
        :usePropRecords="true"
        :listingComponent="true"
        :isCheckable="false"
        :linkView="linkView"
        :maxTextLength="'24'"
        :customLinkView="'importRawData'"
        :isLoading="isDataLoading"
        @downloadFile="downloadProductSheetWithError"
        @loadNextPage="pullNextPage"
        :enableInfiniteScroll="true"
        :hasNextData="nextData"
        :hasPreviousData="previousData"
        @loadPreviousPage="pullPreviousPage"
        @backendSort="sortData"
        @querySet="searchByFilter"
        :backendSortingEnabled="true"
        :routeNext="true"
        :allCustomers="customers"
        :allUsers="users"
      />
      <div class="records-displayed" v-if="totalRecords > 0">
        <span v-if="isCheckedAll"> All selected, </span>
        <span v-if="checkedData.length > 0 && !isCheckedAll"
          >{{ checkedData.length }} selected,
        </span>
        <span v-if="currentPage * 50 + 50 < totalRecords"
          >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
          {{
            currentPage > 0
              ? nextPageCursor
                ? currentPage * 50 - 50 + tableData.length
                : totalRecords
              : tableData.length
          }}
          records out of {{ totalRecords }} records</span
        >
        <div v-else>
          <span v-if="currentPage == 0">
            displaying 0 - {{ totalRecords }} records out of
            {{ totalRecords }} records
          </span>
          <span v-else>
            displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
            out of {{ totalRecords }} records
          </span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import Circul8Table from "../../components/Circul8Table.vue";
import DataManagementService from "../../services/DataManagementImportService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import UtilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import UserDataService from "@/services/UserDataService";
import * as dayjs from "dayjs";
import { UserGroup } from "@/services/UserGroups";
import { mapGetters } from "vuex";

export default {
  name: "DataManagementImport",
  mixins: [UtilityMixin, ScopeMixin],
  components: { HeroBar, TitleBar, Circul8Table },
  data() {
    return {
      tableData: [],
      checkedData: [],
      checkedRows: [],
      map1: new Map(),
      isCheckedAll: false,
      checkedDataMap: new Map(),
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: false,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      isDataLoading: false,
      linkView: "datamanagement.viewRawData",
      customers: [],
      userDataService: new UserDataService(),
      users: [],
      columns: [
        {
          field: "customer_name",
          label: "Customer Name",
          searchable: true,
          width: "200",
          type: "multiSelectFilter",
          visible: true,
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "additional_info",
          allStatusVals: this.customers,
          initStatusVals: [],
          multiSelectFilter: true,
          filterKey: { customer_name: [] }
        },

        {
          field: "status",
          label: "Status",
          searchable: true,
          type: "input",
          filterKey: { status: "" }
        },
        {
          field: "imported_by_user",
          label: "Imported By",
          searchable: true,
          visible: true,
          allStatusVals: this.users,
          initStatusVals: [],
          multiSelectFilter: true,
          type: "multiSelectFilter",
          filterKey: { imported_by_user: [] }
        },
        {
          field: "created_at",
          label: "Imported On",
          searchable: true,
          filterKey: { created_at: "" },
          type: "dateField"
        },
        {
          field: "import_type",
          label: "Import Type",
          searchable: true,
          type: "input",
          filterKey: { import_type: "" }
        },
        {
          field: "period",
          label: "Period",
          searchable: true,
          type: "input",
          filterKey: { period: "" }
        },
        {
          field: "document",
          label: "Attached Document",
          searchable: true,
          type: "input",
          filterKey: { document: "" }
        },
        {
          field: "comment",
          label: "Comment",
          searchable: true,
          type: "input",
          filterKey: { comment: "" },
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "comment"
        },
        {
          field: "failure_details",
          label: "Failure Details",
          searchable: true,
          type: "input",
          filterKey: { failure_details: "" },
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "failure_details"
        },

        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          sortable: 1,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ],
      DataManagementService: new DataManagementService(),
      customerDataService: new CustomerProfileDataService()
    };
  },
  mounted() {
    this.fetchUserData();
    this.checkExternalPermission();
    this.fetchRawDataImportData();
    this.fetchCustomerData();
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    isEditAllowed() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        // this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE) ||
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      } else {
        return false;
      }
    },
    titleStack() {
      return [
        { url: "#", name: "Data Management" },
        { url: "/datamangement/importRawData", name: "Import Raw Data" }
      ];
    }
  },
  watch: {
    users(newValue) {
      this.fetchInternalUserData(newValue);
    }
  },
  methods: {
    downloadProductSheetWithError(data) {
      try {
        this.DataManagementService.exportProductSheetWithError(
          data.id,
          data.customer_name
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    routeToImportForm() {
      this.$router.push({
        name: "datamanagement.importRawDataForm",
        params: { isRawData: true }
      });
    },
    fetchRawDataImportData(query = "", scrollDir) {
      this.isDataLoading = true;
      this.DataManagementService.getAllIRawDatamport(query).subscribe(
        response => {
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }
          this.totalRecords = response["count"];
          let tempData = [];
          if (scrollDir == "next") {
            if (!this.nextPageCursor) {
              this.prepareData(response["results"], scrollDir);
            } else {
              tempData = [...this.tableData, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.prepareData(tempData);
            }
          } else if (scrollDir == "prev") {
            if (this.currentPage == 0) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...response["results"], ...this.tableData];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }
              this.prepareData(tempData);
            }
          } else {
            this.prepareData(response["results"]);
          }
        },
        e => {
          this.nextData = false;
          this.isDataLoading = false;
        }
      );
    },
    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        // if (reportData["documents"].length > 0) {
        //   if (reportData["documents"].length == 1) {
        //     for (const document of reportData["documents"]) {
        //       reportData["document"] = this.getFileName(document["document"]);
        //     }
        //   } else {
        //     reportData[
        //       "document"
        //     ] = `${reportData["documents"].length} files are uploaded`;
        //   }
        // }
        reportData["document"] = reportData["documents_names"];
        reportData["number_of_downloadable_file"] = 1;
        reportData["document_file_count"] =
          reportData["documents_names"].length;
        reportData["updated_at"] = this.dateToLocalDate(
          reportData["updated_at"]
        );
        reportData["created_at"] = dayjs(reportData["created_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        reportData["disabledView"] =
          reportData["status"] === "Completed and Validated" ||
          reportData["status"] === "Complete" ||
          reportData["status"] === "In Validation" ||
          reportData["status"] === "Merging Failed"
            ? true
            : false;
        reportData["actions"] = false;
        dataList.push(reportData);
      }
      if (this.nextPageCursor == null) {
        this.tableData.push(...dataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.tableData = dataList;
      }
      //if select all checkbox clicked the show all the data for the page as checked
      if (this.isCheckedAll) {
        this.checkedRows = this.tableData;
      } else {
        //else show the corresponding data from the dictionay map1
        const temp = [];
        // check if dictionary has value or not
        if (
          this.map1.get(this.currentPage) &&
          this.map1.get(this.currentPage).length > 0
        ) {
          //inserting data according to index of the current page
          this.map1.get(this.currentPage).forEach(element => {
            temp.push(this.tableData[element]);
          });
          this.checkedRows = temp;
        } else {
          this.checkedRows = [];
        }
      }
      this.isDataLoading = false;
    },
    getFileName(file) {
      const cleanFile = file.substring(file.lastIndexOf("/") + 1);
      return this.decodedString(cleanFile);
    },
    decodedString(encodedString) {
      // Decode the URL-encoded string
      return decodeURIComponent(encodedString);
    },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.query = "&" + this.query;
        this.fetchRawDataImportData(this.query, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query = query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchRawDataImportData(this.query, "prev");
    },
    checkedAllData(value) {
      this.isCheckedAll = value;
      if (!this.isCheckedAll) {
        this.checkedRows = [];
        this.map1 = new Map();
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRows = [];
      } else {
        this.checkedDataMap.set(this.currentPage, this.tableData);
      }
    },
    checkCheckBox(d) {
      // select all should be false now
      const total_checked = this.checkedData.length;
      const indexs = [];
      //getting the index of the checked rows
      d.forEach(element => {
        const index = this.tableData.findIndex(object => {
          return element.id === object.id;
        });
        indexs.push(index);
      });
      // create 2 dictonary. one with indexes for showing current page selected another with checked row vvalue
      this.map1.set(this.currentPage, indexs);

      if (d.length > 0) {
        this.checkedDataMap.set(this.currentPage, d);
      } else {
        !this.isCheckedAll && this.checkedDataMap.set(this.currentPage, d);
      }
      this.checkedRows = d;
      this.checkedData = [];
      // converting mapped data into array for bulk operations
      this.checkedDataMap.forEach(element => {
        this.checkedData.push(...element);
      });
      // if checked all is true and deselect any
      if (this.isCheckedAll && total_checked > this.checkedData.length) {
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRows = [];
        this.map1 = new Map();
      }
    },
    searchByFilter(filterQuery) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.map1 = new Map();
      this.checkedRows = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      this.query = filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      // Maintaining sort column & order in separate varaibles instead of this.query as it becomes difficult to replace & maintain
      // sort column & order part of this.query string. We should maintain query params in associative array instead of string
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn;
        query += "&order_by" + "=" + this.lastSortOrder;
        query += "&" + this.query;
      } else {
        query = this.query;
      }
      this.fetchRawDataImportData(query);
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.nextData = false;
      this.currentPage = 0;
      this.tableData = [];
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      const oldOrderField = "&order_field" + "=" + this.lastSortColumn + "&";
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder + "&";
      const newOrderField = "&order_field" + "=" + field + "&";
      const newOrderValue = "&order_by" + "=" + order + "&";

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchRawDataImportData(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },

    fetchInternalUserData(newValue) {
      const userIndex = this.find_column_index("imported_by_user");
      this.columns[userIndex]["allStatusVals"] = newValue;
      for (const user of this.users) {
        if (user.is_active == false) {
          user.name = user.name + "(Inactive)";
        }
      }
    },

    fetchCustomerData() {
      this.customerDataService.getCustomerListForImport().subscribe(
        response => {
          const data = response;
          const customerNameIndex = this.find_column_index("customer_name");
          this.columns[customerNameIndex].allStatusVals = data;
          this.customers = data;
        },
        e => {
          console.log(e);
        }
      );
    }
  }
};
</script>
